export default {
    methods: {
        transferToStore(item, action) {
            const payload = {
                item,
                action
            };
            this.$store.dispatch('conciliationStore/selectTransfer', payload);
        },
        operationToStore(item, action) {
            const payload = {
                item,
                action
            };
            this.$store.dispatch('conciliationStore/selectOperation', payload);
        },
        autoSelectElements(data) {
            // console.warn('>>> AutoSelectElements');
            const { transactions, operations } = data;
            transactions.forEach(item => {
                const transactionsList = this.$store.getters['conciliationStore/transfers'];
                const indexTransfer = transactionsList.findIndex(x => x.uuid === item.uuid);
                if (indexTransfer < 0) {
                    this.transferToStore(item, 'add');
                }
            });
            operations.forEach(item => {
                const operationsList = this.$store.getters['conciliationStore/operations'];
                const indexOperation = operationsList.findIndex(x => x.uuid === item.uuid);
                if (indexOperation < 0) {
                    this.operationToStore(item, 'add');
                }
            });
        },
        clearSelection(notFetch) {
            this.$store.dispatch('conciliationStore/removeTransfersSelected');
            this.$store.dispatch('conciliationStore/removeOperationsSelected');
            this.$store.dispatch('conciliationStore/setGroupedSelected', false);
            this.$store.dispatch('conciliationStore/setSuggestions', false);
            this.$store.dispatch('conciliationStore/disableGroups', false);
            this.$store.dispatch('conciliationStore/disableAll', false);
            this.$store.dispatch('conciliationStore/setComment', null);
            this.$root.$emit('height_resume', 0);
            if (notFetch !== true) {
                this.$root.$emit('filter_transactions', false);
                this.$root.$emit('filter_operations', false);
                // this.$root.$emit('clear_all_conciliation');
            }
        }
    }
};
